/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserCampaignHistoryUpdateRequest } from '../models/UserCampaignHistoryUpdateRequest';
import type { UserConsentUpdateRequest } from '../models/UserConsentUpdateRequest';
import type { UserCreateRequest } from '../models/UserCreateRequest';
import type { UserDeletionResponse } from '../models/UserDeletionResponse';
import type { UserListResponse } from '../models/UserListResponse';
import type { UserResponse } from '../models/UserResponse';
import type { UserSearchResponse } from '../models/UserSearchResponse';
import type { UserUpdateRequest } from '../models/UserUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Create new user
     * Create a new user with consent tracking and return the user profile
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static createUserApiUsersPost({
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        requestBody: UserCreateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List users with campaign history
     * Get list of users with campaign_history field (Worker usage)
     * @returns UserListResponse Successful Response
     * @throws ApiError
     */
    public static listUsersApiUsersGet({
        offset,
        limit = 20,
        consentPrivacy,
        consentPersonalData,
        consentMarketing,
        xServiceToken,
        xApiKey,
        session,
    }: {
        /**
         * Pagination offset
         */
        offset?: number,
        /**
         * Maximum number of users to return
         */
        limit?: number,
        /**
         * Filter by privacy consent
         */
        consentPrivacy?: (boolean | null),
        /**
         * Filter by personal data consent
         */
        consentPersonalData?: (boolean | null),
        /**
         * Filter by marketing consent
         */
        consentMarketing?: (boolean | null),
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'consent_privacy': consentPrivacy,
                'consent_personal_data': consentPersonalData,
                'consent_marketing': consentMarketing,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all users with campaign history (Worker only)
     * Fetch all users with campaign_history field for Worker task generation
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static getAllUsersForCampaignsApiUsersAllGet({
        xServiceToken,
        xApiKey,
        session,
    }: {
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Array<UserResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/all',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Search users by telegram ID, username, or auth code
     * Universal search endpoint with automatic query type detection
     * @returns UserSearchResponse Successful Response
     * @throws ApiError
     */
    public static searchUsersApiUsersSearchGet({
        q,
        limit = 10,
        xServiceToken,
        xApiKey,
        session,
    }: {
        /**
         * Search query (telegram_id, @username, or 6-digit code)
         */
        q: string,
        /**
         * Maximum number of results to return
         */
        limit?: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/search',
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'q': q,
                'limit': limit,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user profile
     * Get complete user profile including interests and balance
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static getUserApiUsersTelegramIdGet({
        telegramId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{telegram_id}',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update user profile
     * Update user profile data and return the modified profile
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static updateUserApiUsersTelegramIdPut({
        telegramId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        requestBody: UserUpdateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{telegram_id}',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete user
     * Perform GDPR-compliant deletion of all user data
     * @returns UserDeletionResponse Successful Response
     * @throws ApiError
     */
    public static deleteUserApiUsersTelegramIdDelete({
        telegramId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserDeletionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{telegram_id}',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update consent preferences
     * Update user consent preferences and log the change with timestamp
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static updateConsentApiUsersTelegramIdConsentPut({
        telegramId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        requestBody: UserConsentUpdateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{telegram_id}/consent',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Add user interest
     * Add an interest to user profile
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static addInterestApiUsersTelegramIdInterestsPost({
        telegramId,
        interest,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        /**
         * Interest to add
         */
        interest: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{telegram_id}/interests',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'interest': interest,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Remove user interest
     * Remove an interest from user profile
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static removeInterestApiUsersTelegramIdInterestsDelete({
        telegramId,
        interest,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        /**
         * Interest to remove
         */
        interest: string,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{telegram_id}/interests',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            query: {
                'interest': interest,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user balance
     * Get user's current points balance quickly (under 200ms)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getUserBalanceApiUsersTelegramIdBalanceGet({
        telegramId,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{telegram_id}/balance',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update user campaign participation (Worker only)
     * Update user's campaign_history for a specific campaign (Worker usage)
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public static updateUserCampaignHistoryApiUsersTelegramIdCampaignHistoryPatch({
        telegramId,
        requestBody,
        xServiceToken,
        xApiKey,
        session,
    }: {
        telegramId: number,
        requestBody: UserCampaignHistoryUpdateRequest,
        xServiceToken?: (string | null),
        xApiKey?: (string | null),
        session?: (string | null),
    }): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/{telegram_id}/campaign-history',
            path: {
                'telegram_id': telegramId,
            },
            cookies: {
                'session': session,
            },
            headers: {
                'X-Service-Token': xServiceToken,
                'X-API-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User not found`,
                422: `Validation Error`,
                500: `Internal server error`,
            },
        });
    }
}
